var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0248 0.0195312C4.96114 0.0195312 0 4.96965 0 11.0664C0 16.5787 4.03506 21.154 9.3049 21.9809V14.2635H6.50461V11.0664H9.3049V8.62987C9.3049 5.86266 10.9476 4.34124 13.4723 4.34124C14.674 4.34124 15.9308 4.55071 15.9308 4.55071V7.27382H14.5417C13.1746 7.27382 12.7446 8.12273 12.7446 8.99371V11.0664H15.8095L15.3134 14.2635H12.7446V21.9809C15.3425 21.5705 17.7082 20.245 19.4145 18.2435C21.1208 16.2421 22.0555 13.6964 22.0495 11.0664C22.0495 4.96965 17.0884 0.0195312 11.0248 0.0195312Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.d01960dc719660b0ec7f5a1d4c1fcc0d.svg";
export { ForwardRef as ReactComponent };